<template>
  <div>
    <t-dialog header="图片素材库" v-model:visible="modelShow" width="75%" :closeOnOverlayClick="false" top="50px" @confirm="confirmCheck">
      <t-form layout="inline" :model="searchForm">
        <t-button @click="showForm(false,null)" v-if="!readOnly">上传</t-button>
        <t-form-item label="资源名">
          <t-input v-model="searchForm.imgName" placeholder="请输入资源名"/>
        </t-form-item>
        <t-button @click="onSearch">查询</t-button>
        <t-loading size="small" :loading="loading"/>
      </t-form>
      <div style="width: 100%;height: 40px;cursor: pointer;border-bottom: 1px solid #444;">
        <div class="group-item" v-for="item in groupPanes" :key="item.id" @click="tabChange(item)"
             :class="item.id===activeGroup?'group-item-active':'group-item-hover'">
          {{item.groupName}}
          <div class="group-item-del-tag" @click.stop="delGroup(item)"><t-icon name="close"/></div>
        </div>
        <div style="float: left;line-height:40px;height: 100%;" v-show="groupPanes.length<10">
          <div class="group-item-hover" v-show="!adding" style="font-size: 20px;line-height: 36px;padding: 0 18px;" @click="adding = true" v-if="!readOnly">+</div>
          <div v-if="adding" style="padding: 10px 6px;height: 100%">
            <t-input v-model="iptGroupName" size="small" autofocus @blur="confirmAddGroup"/>
          </div>
        </div>
      </div>
      <t-row :gutter="6" style="padding-top: 10px;width: 100%;overflow: hidden">
        <t-col :span="2" v-for="item2 in imgData" :key="item2.id" @click.native="checkImg(item2)">
          <div class="img-box" :style="checkedItem.id === item2.id ? 'border: 1px solid #409eff;box-shadow: 0 0 2px 1px #4582e6':'border: 1px solid transparent;'">
            <t-image style="width: 100%; height: 100%" :src="fileUrl+item2.filePath" fit="contain"/>
            <div class="del-tag" @click="delItem(item2)" v-if="!readOnly">
              <t-icon name="delete" style="font-weight: bold;color:#fff"/>
            </div>
          </div>
          <div style="height: 20px;margin-bottom: 6px;overflow: hidden">{{ item2.imgName }}</div>
        </t-col>
      </t-row>
      <t-pagination style="margin-top: 20px" size="small"
                    @page-size-change="handleSizeChange" @current-change="handleCurrentChange"
                    :current="pageConfig.pageNo" :page-size.sync="pageConfig.pageSize" :pageSizeOptions="[12,24,60]"
                    :total="pageConfig.total">
      </t-pagination>
    </t-dialog>
    <ImgPoolForm ref="imgPoolForm" @refreshTable="loadData" :groupId="pageConfig.groupId"/>
  </div>
</template>

<script>
import {listGroupAllApi, saveOrUpdateApi} from "@/api/img-group-api";
import {delApi, delGroupApi, pageListApi} from "@/api/img-pool";
import {fileUrl} from "/env";
import ImgPoolForm from "@/views/manage/design/form/img-pool-form";

export default {
  name: "Gallery",
  components: {ImgPoolForm},
  props:{
    readOnly:{
      type: Boolean,
      default: false
    }
  },
  data(){
    return {
      fileUrl,
      searchForm:{imgName:""},
      groupPanes:[],
      imgData:[],
      modelShow:false,
      groupLoaded:false,
      activeGroup:'',
      pageConfig:{
        groupId:'',
        pageNo:1,
        pageSize:12,
        total:0
      },
      checkedItem:{},
      formGroup:{name:''},
      loading:false,
      adding:false,
      iptGroupName:''
    }
  },
  methods:{
    confirmAddGroup(){
      if(!this.iptGroupName){
        this.adding = false;
        return;
      }
      this.loading = true;
      saveOrUpdateApi({groupName:this.iptGroupName}).then(res => {
        this.iptGroupName = '';
        this.adding = false;
        this.groupPanes.push(res.data);
        this.loading = false;
      })
    },
    delGroup(item){
      const confirmDia = this.$dialog.confirm({
        header: '危险',
        body: '此操作将永久删除当前文件夹下的文件, 是否继续?',
        confirmBtn: '确定',
        cancelBtn: '取消',
        onConfirm: () => {
          delGroupApi(item.id).then(() => {
            this.$message.success('删除成功');
            this.opened();
            confirmDia.destroy();
          })
        },
        onClose: () => {confirmDia.hide()},
      });
    },
    showForm(isEdit,row){
      let rowData = {}
      if(isEdit){
        rowData = JSON.parse(JSON.stringify(row))
      }
      this.$refs.imgPoolForm.opened(isEdit, rowData);
    },
    onSearch(){
      this.pageConfig.pageNo = 1;
      this.pageConfig.pageSize = 12;
      this.loadData();
    },
    opened(){
      this.modelShow = true
      if(this.groupLoaded){
        return
      }
      listGroupAllApi().then(res => {
        this.groupPanes = res.data;
        this.activeGroup = this.groupPanes[0].id
        this.groupLoaded = true
        this.onSearch();
      })
    },
    loadData(){
      this.loading = true
      this.pageConfig.groupId = this.activeGroup;
      pageListApi(Object.assign(this.searchForm,this.pageConfig)).then(res => {
        this.imgData = res.data.records;
        this.pageConfig.total = res.data.total
        this.loading = false
      })
    },
    confirmCheck(){
      if (!this.checkedItem || !this.checkedItem.id){
        this.$message.error('请选择图片')
      }else {
        this.$emit('confirmCheck', this.checkedItem.filePath);
        this.modelShow = false
      }
    },
    delItem(item){
      const confirmDia = this.$dialog.confirm({
        header: '警告',
        body: '此操作将永久删除该文件, 是否继续?',
        confirmBtn: '确定',
        cancelBtn: '取消',
        onConfirm: () => {
          delApi(item.id).then(() => {
            this.$message.success('删除成功');
            this.loadData();
            confirmDia.destroy();
          })
        },
        onClose: () => {confirmDia.hide()},
      });
    },
    checkImg(item){
      this.checkedItem = item
    },
    removeTab(targetName) {//询问处理、当前选中项处理、刷新处理
      /*this.groupPanes = this.groupPanes.filter(tab => tab.id !== targetName);
      this.activeGroup = this.groupPanes[0].id*/
      console.log(targetName)
    },
    tabClick() {
      this.pageConfig.pageNo = 1;
      this.loadData();
    },
    tabChange(item){
      this.activeGroup = item.id;
      this.onSearch();
    },
    handleSizeChange(val) {
      this.pageConfig.pageSize = val;
      this.loadData();
    },
    handleCurrentChange(val) {
      this.pageConfig.pageNo = val;
      this.loadData();
    },
  }
}
</script>

<style scoped>
.img-box{height: 150px;position: relative;cursor: pointer;}
.del-tag{width: 20px;height: 20px;position: absolute;right: 0;top:0;display: none;cursor: pointer}
.img-box:hover .del-tag{display:block;}
.group-item{float: left;padding: 0 18px 0 18px;line-height:40px;height: 100%;position: relative}
.group-item-active{border-bottom: 1px solid #4582e6;color:#4582e6}
.group-item-hover:hover{background-color: #2c2c2c}
.group-item-del-tag{position: absolute;height: 100%;right: 0;top: 0;display: none;line-height: 36px;}
.group-item-active:hover .group-item-del-tag{display: block}
</style>
